import * as DTO from '../dto';
import { getTRPCClient } from './getTRPCClient';

export const approveMTS = async (token: string, formInput: DTO.SubmitFormInput) => {
  const client = getTRPCClient();
  return client.mutation('approveMTS', { token, formInput });
};
